<template>
  <v-app>
    <hr />
    <v-app-bar dark color="#3949AB" app>
      <v-toolbar-title>メニュー</v-toolbar-title>
      <v-spacer></v-spacer>
      <div v-for="(item, index) in routes" :key="index">
        <RyouMenu
          :iconContent="item.iconCls"
          :childrenList="item.children"
        ></RyouMenu>
      </div>
      {{ this.$store.getters.getName }}
    </v-app-bar>
    <v-main>
      <div
        class="homeWelcome"
        v-if="this.$router.currentRoute.path == '/home'"
      ></div>
      <!--
            <v-toolbar-title>
                <v-breadcrumbs class="hidden-sm-and-down" large style="padding:0px !important" v-if="this.$router.currentRoute.path!='/home'">
                    <v-breadcrumbs-item>
                        {{this.$router.currentRoute.name}}
                    </v-breadcrumbs-item>
                </v-breadcrumbs>
            </v-toolbar-title>
            -->
      <router-view />
    </v-main>
    <v-footer dark color="#3949AB" style="height: 1%" app> </v-footer>
  </v-app>
</template>

<script>
import RyouMenu from "@/components/menu/RyouMenu";

export default {
  name: "Home",
  components: {
    RyouMenu,
  },
  data() {
    return {};
  },
  mounted() {},
  created() {},
  computed: {
    routes() {
      return this.$store.state.routes;
    },
  },
  methods: {},
};
</script>
